export default class QueryString {
  static getQueryStringData(qs = null) {
    const uriSearch = qs || location.search;
    let str = decodeURIComponent(uriSearch);
    if (typeof str !== 'string') return {};
    str = str.trim().replace(/^\?/, '');
    if (!str) return {};

    return str.trim().split('&').reduce(function (ret, param) {
      const parts = param.replace(/\+/g, ' ').split('=');
      let key = parts[0];
      let val = parts[1];

      val = val === undefined ? null : val;

      if (ret[key] && Array.isArray(ret[key])) {
        const index = ret[key].indexOf(val);
        if (index < 0) ret[key].push(val);
      } else {
        if (key.indexOf('[]') > -1) ret[key] = [val];
        else ret[key] = val;
      }

      return ret;
    }, {});
  }

  static parseQueryStringData(obj) {
    return $.param(obj);
  }
}
